import React, { FC } from 'react';
import { Badge, BadgeType } from '@components/atoms/Badge';
import { useTranslation } from 'react-i18next';

interface CouponStateBadgeProps {
    state: string;
}

export const CouponStateBadge: FC<CouponStateBadgeProps> = ({ state }) => {
    const { t } = useTranslation();

    const translations = {
        activeLabel: t('coupon-state.active'),
        inactiveLabel: t('coupon-state.inactive'),
        expiredLabel: t('coupon-state.expired'),
    };

    switch (state) {
        case 'active':
            return <Badge label={translations.activeLabel} type={BadgeType.success} icon="fa-light fa-check" />;
        case 'inactive':
            return <Badge label={translations.inactiveLabel} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        case 'expired':
            return <Badge label={translations.expiredLabel} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        default:
            <></>;
    }
};
